// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"524":"57b68b4b","539":"bf5a8a8a"}[chunkId] + ".chunk.js";
};